export const ENGLISH = 'English';
export const JAPANESE = '日本語';
export const SPANISH = 'Español';
